import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { translationEn } from "./locales/en/translation";
import { translationAr } from "./locales/ar/translation";

const resources = {
  en: {
    translation: {
      ...translationEn,
    },
  },
  ar: {
    translation: {
      ...translationAr,
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "ar",
    lng: localStorage.getItem('i18nextLng') || 'ar',
    supportedLngs: ["en", "ar"],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
